import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Program from './components/Program';
import Environment from './components/Environment';
import Nutrition from './components/Nutrition';
import Partnership from './components/Partnership';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Program />
      <Environment />
      <Nutrition />
      <Partnership />
      <Contact />
      <Footer />
    </div>
  );
}
